/* Rokid HK — rokid-index.js (safe: guards missing elements) */

/* ============ i18n ============ */
const root = document.documentElement;
const langSel = document.getElementById('langSel');
const langBtn = document.getElementById('langBtn');
function setLang(l){
  root.dataset.lang = l;
  root.lang = l === 'zh' ? 'zh-Hant-HK' : 'en';
  document.querySelectorAll('[data-zh]').forEach(el => { el.textContent = l==='zh' ? el.dataset.zh : el.dataset.en; });
  const lc = document.getElementById('langCur');
  if (lc) lc.textContent = l === 'zh' ? '繁' : 'EN';
  document.querySelectorAll('.lang-menu button').forEach(b => b.classList.toggle('on', b.dataset.lang === l));
  try{ localStorage.setItem('rokid-hk-lang', l); }catch(e){}
}
if (langSel && langBtn){
  langBtn.addEventListener('click', e => {
    e.stopPropagation();
    const open = langSel.classList.toggle('open');
    langBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  langSel.querySelectorAll('.lang-menu button').forEach(b => b.addEventListener('click', e => {
    e.stopPropagation();
    setLang(b.dataset.lang);
    langSel.classList.remove('open');
    langBtn.setAttribute('aria-expanded', 'false');
  }));
  document.addEventListener('click', () => { langSel.classList.remove('open'); langBtn.setAttribute('aria-expanded', 'false'); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape'){ langSel.classList.remove('open'); langBtn.setAttribute('aria-expanded', 'false'); } });
}

/* ============ countdowns ============ */
const OPEN_AT = new Date('2026-09-30T10:00:00+08:00');
const PRESALE_AT = new Date('2026-09-01T10:00:00+08:00');
/* phase gates (auto reveal by date) */
document.querySelectorAll('[data-phase]').forEach(el => {
  const p = el.dataset.phase;
  const show = (p === 'presale' && Date.now() >= +PRESALE_AT) || (p === 'open' && Date.now() >= +OPEN_AT);
  el.hidden = !show;
});
const pad = n => String(n).padStart(2,'0');
const cdCells = {};
document.querySelectorAll('#cj-cd .num').forEach(el => { (cdCells[el.dataset.u] = cdCells[el.dataset.u] || []).push(el); });
const cdBars = document.querySelectorAll('#cd-bar-i');
function setCell(els, str){
  if (!els || !els.length) return;
  els.forEach(el => {
    if (!el.children.length) el.textContent = '';
    for (let i = 0; i < str.length; i++){
      let b = el.children[i];
      if (!b){ b = document.createElement('b'); el.appendChild(b); }
      if (b.textContent !== str[i]){
        b.textContent = str[i];
        b.classList.remove('tick');
        void b.offsetWidth;
        b.classList.add('tick');
      }
    }
  });
}
function tick(){
  document.querySelectorAll('.cd-grid').forEach(g => {
    let target = new Date(g.dataset.openAt || OPEN_AT);
    if (isNaN(target)) target = OPEN_AT;
    let diff = Math.max(0, target - Date.now());
    const d = Math.floor(diff / 864e5); diff -= d * 864e5;
    const h = Math.floor(diff / 36e5); diff -= h * 36e5;
    const m = Math.floor(diff / 6e4); diff -= m * 6e4;
    const s = Math.floor(diff / 1e3);
    const cells = {};
    g.querySelectorAll('.num').forEach(el => { (cells[el.dataset.u] = cells[el.dataset.u] || []).push(el); });
    setCell(cells.d, String(d).padStart(3,'0'));
    setCell(cells.h, pad(h));
    setCell(cells.m, pad(m));
    setCell(cells.s, pad(s));
    const bar = g.parentElement ? g.parentElement.querySelector('.cd-bar i') : null;
    if (bar) bar.style.width = (((59 - s) / 59) * 100).toFixed(1) + '%';
  });
}
setInterval(tick, 1000); tick();

/* ============ KV / layers / hook-bg asset detection ============ */
(function(){
  const hero = document.querySelector('.p-hero');
  if (hero){
    const kv = hero.querySelector('.kv-asset');
    const st = { bg: false, fg: false, still: false };
    const decide = () => {
      const hasKv = hero.classList.contains('has-kv');
      hero.classList.toggle('has-layers', st.fg || (!hasKv && st.bg));
      hero.classList.toggle('has-still', !hasKv && !st.bg && !st.fg && st.still);
    };
    if (kv && kv.tagName === 'VIDEO') kv.addEventListener('loadeddata', () => { hero.classList.add('has-kv'); decide(); });
    [['.kvl-bg','bg'], ['.kvl-fg','fg'], ['.kvl-still','still']].forEach(([sel, key]) => {
      const el = hero.querySelector(sel);
      if (!el) return;
      const ok = () => { el.classList.add('ok'); st[key] = true; decide(); };
      if (el.complete && el.naturalWidth > 0) ok();
      else el.addEventListener('load', ok);
    });
  }
  const hook = document.querySelector('.hook');
  const hb = document.querySelector('.hook-bg img');
  if (hook && hb){
    const ok = () => hook.classList.add('has-bg');
    if (hb.complete && hb.naturalWidth > 0) ok();
    else hb.addEventListener('load', ok);
  }
})();

/* ============ media slots ============ */
document.querySelectorAll('.media').forEach(box => {
  box.querySelectorAll('.media-asset').forEach(asset => {
    const ok = () => box.classList.add('has-asset');
    if (asset.tagName === 'IMG'){
      if (asset.complete && asset.naturalWidth > 0) ok();
      else asset.addEventListener('load', ok);
    } else if (asset.tagName === 'VIDEO'){
      asset.addEventListener('loadeddata', ok);
    }
  });
});
document.querySelectorAll('.logo-slot').forEach(box => {
  const asset = box.querySelector('.ls-asset');
  if (!asset) return;
  const ok = () => box.classList.add('has-asset');
  if (asset.complete && asset.naturalWidth > 0) ok();
  else asset.addEventListener('load', ok);
});

/* ---- mobile asset variants: assets/xxx-m.jpg auto-detected on ≤700px ---- */
if (window.matchMedia('(max-width:700px)').matches){
  document.querySelectorAll('.media img.media-asset, .hook-bg img, .kv-layers img').forEach(img => {
    const src = img.getAttribute('src');
    if (!src) return;
    const m = src.replace(/(\.[a-z0-9]+)$/i, '-m$1');
    if (m === src) return;
    const probe = new Image();
    probe.onload = () => { img.src = m; };
    probe.src = m;
  });
}
const vio = new IntersectionObserver(entries => {
  entries.forEach(e => { e.isIntersecting ? e.target.play().catch(()=>{}) : e.target.pause(); });
}, {threshold:.25});
document.querySelectorAll('video.media-asset').forEach(v => vio.observe(v));

/* ============ scroll reveal ============ */
const rio = new IntersectionObserver(entries => {
  entries.forEach(e => { if (e.isIntersecting){ e.target.classList.add('in'); rio.unobserve(e.target); } });
}, {threshold:.12});
document.querySelectorAll('.rv').forEach(el => rio.observe(el));

/* ============ hero bare-eye parallax layers ============ */
(function(){
  const hero = document.querySelector('.p-hero');
  if (!hero) return;
  const fg = hero.querySelector('.kvl-fg');
  const bg = hero.querySelector('.kvl-bg');
  const finePointer = window.matchMedia('(pointer: fine)').matches;
  let mx = 0, my = 0, smx = 0, smy = 0;
  if (finePointer){
    hero.addEventListener('mousemove', e => {
      const r = hero.getBoundingClientRect();
      mx = ((e.clientX - r.left) / r.width - 0.5) * 2;
      my = ((e.clientY - r.top) / r.height - 0.5) * 2;
    });
    hero.addEventListener('mouseleave', () => { mx = 0; my = 0; });
  }
  let running = true;
  const t0 = performance.now();
  function frame(now){
    if (running){
      const t = (now - t0) / 1000;
      smx += (mx - smx) * 0.06;
      smy += (my - smy) * 0.06;
      const idle = Math.sin(t * 0.45) * 6;
      const sway = Math.sin(t * 0.22) * 10;
      if (bg){
        bg.style.transform = `translate3d(${(-smx * 10).toFixed(1)}px, ${(-smy * 7).toFixed(1)}px, 0)`;
      }
      if (fg){
        const x = smx * 20 + (finePointer ? 0 : sway);
        const y = smy * 13 + idle;
        fg.style.transform = `translate(${x.toFixed(1)}px, calc(-50% + ${y.toFixed(1)}px)) rotate(${(smx * 1.1).toFixed(2)}deg)`;
      }
    }
    requestAnimationFrame(frame);
  }
  new IntersectionObserver(e => { running = e[0].isIntersecting; }, {threshold: 0.02}).observe(hero);
  requestAnimationFrame(frame);
})();

/* ============ comparison sliders ============ */
document.querySelectorAll('.cmp').forEach(box => {
  const set = x => {
    const r = box.getBoundingClientRect();
    let p = (x - r.left) / r.width * 100;
    /* 水印 logo 在左下角（left:14px + 88px 宽），拖到其右缘 +20px 余量内直接吸附为 0，保证 logo 轻松完整露出 */
    if (x - r.left <= 134) p = 0;
    box.style.setProperty('--cx', Math.min(96, p).toFixed(1) + '%');
  };
  let down = false;
  box.addEventListener('pointerdown', e => { down = true; set(e.clientX); try{ box.setPointerCapture(e.pointerId); }catch(_){} });
  box.addEventListener('pointermove', e => { if (down) set(e.clientX); });
  ['pointerup','pointercancel','pointerleave'].forEach(ev => box.addEventListener(ev, () => down = false));
  new IntersectionObserver((es, o) => {
    es.forEach(e => {
      if (e.isIntersecting){
        o.unobserve(box);
        const t0 = performance.now();
        (function anim(n){
          const p = Math.min(1, (n - t0) / 1000);
          const ease = 1 - Math.pow(1 - p, 3);
          box.style.setProperty('--cx', (92 - ease * 37).toFixed(1) + '%');
          if (p < 1) requestAnimationFrame(anim);
        })(t0);
      }
    });
  }, {threshold:.4}).observe(box);
});

/* ============ slider chrome: life rows + creators ============ */
(function(){
  const rows = [...document.querySelectorAll('.life-row')];
  if (rows.length){
    rows.forEach(r => r.style.position = 'relative');
    const nav = document.createElement('div');
    nav.className = 'lr-nav';
    nav.innerHTML = '<button type="button" data-d="-1" aria-label="left">‹</button><button type="button" data-d="1" aria-label="right">›</button>';
    rows[0].appendChild(nav);
    const prog = document.createElement('div');
    prog.className = 'lr-prog';
    prog.innerHTML = '<i></i>';
    rows[rows.length - 1].insertAdjacentElement('afterend', prog);
    const bar = prog.firstChild;
    const sync = (src, updateBar) => {
      const ms = src.scrollWidth - src.clientWidth;
      rows.forEach(o => {
        if (o === src) return;
        const mo = o.scrollWidth - o.clientWidth;
        if (ms > 0 && mo > 0) o.scrollLeft = src.scrollLeft / ms * mo;
      });
      if (updateBar) bar.style.width = (ms > 0 ? (34 + src.scrollLeft / ms * 66) : 100) + '%';
    };
    rows.forEach(r => r.addEventListener('scroll', () => requestAnimationFrame(() => sync(r, true)), {passive:true}));
    nav.addEventListener('click', e => {
      const b = e.target.closest('button');
      if (!b) return;
      rows.forEach(r => r.scrollBy({left: Number(b.dataset.d) * r.clientWidth * 0.7, behavior: 'smooth'}));
    });
    sync(rows[0], true);
  }
  const crRow = document.querySelector('.cr-row');
  const crHead = document.querySelector('.cr-head');
  if (crRow && crHead){
    const nav = document.createElement('div');
    nav.className = 'cr-nav';
    nav.innerHTML = '<button type="button" data-d="-1" aria-label="prev">‹</button><button type="button" data-d="1" aria-label="next">›</button>';
    crHead.appendChild(nav);
    nav.addEventListener('click', e => {
      const b = e.target.closest('button');
      if (b) crRow.scrollBy({left: Number(b.dataset.d) * crRow.clientWidth * 0.6, behavior: 'smooth'});
    });
  }
})();

/* ============ section-matched motion ============ */
(function(){
  /* awards: count-up on reveal */
  const nums = [...document.querySelectorAll('.num .v')];
  if (nums.length){
    const animate = el => {
      const host = el.querySelector('.only-zh') || el;
      const numNode = host.childNodes[0];
      if (!numNode || numNode.nodeType !== 3) return;
      const text = numNode.textContent || '';
      const match = text.match(/[\d,.]+/);
      if (!match) return;
      const final = match[0];
      const targetVal = parseFloat(final.replace(/,/g, ''));
      if (isNaN(targetVal)) return;
      const isFloat = final.includes('.');
      const t0 = performance.now();
      (function tick(n){
        const p = Math.min(1, (n - t0) / 1200);
        const e = 1 - Math.pow(1 - p, 3);
        const val = targetVal * e;
        numNode.textContent = text.replace(final, isFloat ? val.toFixed(2) : Math.round(val).toLocaleString());
        if (p < 1) requestAnimationFrame(tick);
      })(t0);
    };
    const io = new IntersectionObserver(es => {
      es.forEach(e => { if (e.isIntersecting){ animate(e.target); io.unobserve(e.target); } });
    }, {threshold:.5});
    nums.forEach(el => io.observe(el));
  }
  /* unmanned: steps chase */
  const steps = document.querySelector('.hook-steps');
  if (steps){
    const bs = [...steps.querySelectorAll('b')];
    let i = 0, timer = null;
    const chase = () => { bs.forEach((b, j) => b.classList.toggle('on', j === i)); i = (i + 1) % bs.length; };
    new IntersectionObserver(es => {
      es.forEach(e => {
        if (e.isIntersecting){ if (!timer){ chase(); timer = setInterval(chase, 1100); } }
        else { clearInterval(timer); timer = null; bs.forEach(b => b.classList.remove('on')); }
      });
    }, {threshold:.4}).observe(steps);
  }
  /* lnb + visit: rows stagger in */
  ['.lnb', '.visit'].forEach(sel => {
    const el = document.querySelector(sel);
    if (!el) return;
    new IntersectionObserver(es => {
      es.forEach(e => { if (e.isIntersecting){ el.classList.add('rows-in'); } });
    }, {threshold:.2}).observe(el);
  });
})();

/* ============ init language ============ */
setLang((document.documentElement.lang || '').toLowerCase().indexOf('zh') === 0 ? 'zh' : 'en');



/* reserve theme header space: KV stays fixed height, text clears overlay nav */
(function(){
  var done = false;
  var setHdr = function(){
    if (done) return;
    var hg = document.getElementById('header-group');
    if (!hg) { done = true; return; }
    if (window.scrollY > 50) return;
    var hero = document.querySelector('.p-hero') || document.querySelector('.hero');
    if (!hero) { done = true; return; }
    var top = hero.getBoundingClientRect().top;
    if (top < 0) top = 0;
    document.documentElement.style.setProperty('--rokid-hdr', top.toFixed(0) + 'px');
    var pad = 0;
    hg.querySelectorAll('#header-component, .header, .header-section, [class*="announce"], :scope > *').forEach(function(el){
      var r = el.getBoundingClientRect();
      if (r.height > 0 && r.height < 300){
        var over = r.bottom - top;
        if (over > pad && over < 300) pad = over;
      }
    });
    document.documentElement.style.setProperty('--rokid-hdr-pad', pad.toFixed(0) + 'px');
    done = true;
  };
  addEventListener('load', setHdr);
  setTimeout(setHdr, 600);
  setTimeout(setHdr, 1600);
  addEventListener('resize', function(){ done = false; setHdr(); });
  setHdr();
})();

/* ============ Shopify theme editor: scoped re-init（不整页刷新） ============
   编辑器局部重渲染某 section 后，仅对该 section 重新绑定显影/交互逻辑。
   线上访问不执行；每个元素以 data-*Bound 去重，绝不重复绑定。 */
function rokidRebind(scope){
  if (!scope || !scope.querySelectorAll) scope = document;
  scope.querySelectorAll('.media').forEach(box => {
    box.querySelectorAll('.media-asset').forEach(asset => {
      const ok = () => box.classList.add('has-asset');
      if (asset.tagName === 'IMG'){
        if (asset.complete && asset.naturalWidth > 0) ok();
        else asset.addEventListener('load', ok);
      } else if (asset.tagName === 'VIDEO'){
        if (asset.readyState >= 2) ok();
        else asset.addEventListener('loadeddata', ok);
      }
    });
  });
  scope.querySelectorAll('.logo-slot').forEach(box => {
    const asset = box.querySelector('.ls-asset');
    if (!asset) return;
    const ok = () => box.classList.add('has-asset');
    if (asset.complete && asset.naturalWidth > 0) ok();
    else asset.addEventListener('load', ok);
  });
  const io = new IntersectionObserver(es => {
    es.forEach(e => { if (e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
  }, {threshold:.12});
  scope.querySelectorAll('.rv').forEach(el => io.observe(el));
  if (window.matchMedia('(max-width:700px)').matches){
    scope.querySelectorAll('.media img.media-asset, .hook-bg img, .kv-layers img, .hero-kv-still').forEach(img => {
      const src = img.getAttribute('src');
      if (!src) return;
      const m = src.replace(/(\.[a-z0-9]+)$/i, '-m$1');
      if (m === src) return;
      const probe = new Image();
      probe.onload = () => { img.src = m; };
      probe.src = m;
    });
  }
  if (typeof setLang === 'function') setLang(document.documentElement.dataset.lang || 'zh');
}
if (window.Shopify && Shopify.designMode){
  document.addEventListener('shopify:section:load', e => {
    rokidRebind(e.target);
    if (typeof rokidRebindExtra === 'function') rokidRebindExtra(e.target);
  });
}

/* ---- index 专属：KV 层显影 + 对比滑块 + 横向滑轨 ---- */
function rokidRebindExtra(scope){
  const hero = scope.matches && scope.matches('.p-hero') ? scope : scope.querySelector('.p-hero');
  if (hero && !hero.dataset.heroBound){
    hero.dataset.heroBound = '1';
    const kv = hero.querySelector('.kv-asset');
    const st = { bg: false, fg: false, still: false };
    const decide = () => {
      const hasKv = hero.classList.contains('has-kv');
      hero.classList.toggle('has-layers', st.fg || (!hasKv && st.bg));
      hero.classList.toggle('has-still', !hasKv && !st.bg && !st.fg && st.still);
    };
    if (kv && kv.tagName === 'VIDEO'){
      if (kv.readyState >= 2){ hero.classList.add('has-kv'); decide(); }
      else kv.addEventListener('loadeddata', () => { hero.classList.add('has-kv'); decide(); });
    }
    [['.kvl-bg','bg'], ['.kvl-fg','fg'], ['.kvl-still','still']].forEach(([sel, key]) => {
      const el = hero.querySelector(sel);
      if (!el) return;
      const ok = () => { el.classList.add('ok'); st[key] = true; decide(); };
      if (el.complete && el.naturalWidth > 0) ok();
      else el.addEventListener('load', ok);
    });
  }

  /* campaign KV on index：编辑器重渲染后显影 */
  var campHero = scope.matches && scope.matches('.hero') ? scope : scope.querySelector('.hero');
  if (campHero && !campHero.dataset.campBound){
    campHero.dataset.campBound = '1';
    var ckv = campHero.querySelector('.hero-kv-asset');
    if (ckv && ckv.tagName === 'VIDEO'){
      if (ckv.readyState >= 2) campHero.classList.add('has-kv');
      else ckv.addEventListener('loadeddata', function(){ campHero.classList.add('has-kv'); });
    }
    var ckvs = campHero.querySelector('.hero-kv-still');
    if (ckvs){
      var cok = function(){ campHero.classList.add('has-kv'); };
      if (ckvs.complete && ckvs.naturalWidth > 0) cok();
      else ckvs.addEventListener('load', cok);
    }
  }
  scope.querySelectorAll('.cmp').forEach(box => {
    if (box.dataset.cmpBound) return;
    box.dataset.cmpBound = '1';
    const set = x => {
      const r = box.getBoundingClientRect();
      let p = (x - r.left) / r.width * 100;
      if (x - r.left <= 134) p = 0;
      box.style.setProperty('--cx', Math.min(96, p).toFixed(1) + '%');
    };
    let down = false;
    box.addEventListener('pointerdown', e => { down = true; set(e.clientX); try{ box.setPointerCapture(e.pointerId); }catch(_){} });
    box.addEventListener('pointermove', e => { if (down) set(e.clientX); });
    ['pointerup','pointercancel','pointerleave'].forEach(ev => box.addEventListener(ev, () => down = false));
  });
  const rows = scope.querySelectorAll('.life-row');
  if (rows.length && !rows[0].querySelector('.lr-nav')){
    rows.forEach(r => r.style.position = 'relative');
    const nav = document.createElement('div');
    nav.className = 'lr-nav';
    nav.innerHTML = '<button type="button" data-d="-1" aria-label="left">‹</button><button type="button" data-d="1" aria-label="right">›</button>';
    rows[0].appendChild(nav);
    nav.addEventListener('click', e => {
      const b = e.target.closest('button');
      if (!b) return;
      rows.forEach(r => r.scrollBy({left: Number(b.dataset.d) * r.clientWidth * 0.7, behavior: 'smooth'}));
    });
  }
  const crRow = scope.querySelector('.cr-row');
  const crHead = scope.querySelector('.cr-head');
  if (crRow && crHead && !crHead.querySelector('.cr-nav')){
    const nav = document.createElement('div');
    nav.className = 'cr-nav';
    nav.innerHTML = '<button type="button" data-d="-1" aria-label="prev">‹</button><button type="button" data-d="1" aria-label="next">›</button>';
    crHead.appendChild(nav);
    nav.addEventListener('click', e => {
      const b = e.target.closest('button');
      if (b) crRow.scrollBy({left: Number(b.dataset.d) * crRow.clientWidth * 0.6, behavior: 'smooth'});
    });
  }
  const langSel = document.getElementById('langSel');
  const langBtn = document.getElementById('langBtn');
  if (langSel && langBtn && !langSel.dataset.langBound){
    langSel.dataset.langBound = '1';
    langBtn.addEventListener('click', e => {
      e.stopPropagation();
      const open = langSel.classList.toggle('open');
      langBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    langSel.querySelectorAll('.lang-menu button').forEach(b => b.addEventListener('click', e => {
      e.stopPropagation();
      setLang(b.dataset.lang);
      langSel.classList.remove('open');
      langBtn.setAttribute('aria-expanded', 'false');
    }));
    document.addEventListener('click', () => { langSel.classList.remove('open'); langBtn.setAttribute('aria-expanded', 'false'); });
  }
}

/* ============ campaign KV on index：显影 + HKT 时钟 ============ */
(function(){
  var hero = document.querySelector('.hero');
  if (hero){
    var kv = hero.querySelector('.hero-kv-asset');
    if (kv && kv.tagName === 'VIDEO'){
      if (kv.readyState >= 2) hero.classList.add('has-kv');
      else kv.addEventListener('loadeddata', function(){ hero.classList.add('has-kv'); });
    }
    var kvs = hero.querySelector('.hero-kv-still');
    if (kvs){
      var ok = function(){ hero.classList.add('has-kv'); };
      if (kvs.complete && kvs.naturalWidth > 0) ok();
      else kvs.addEventListener('load', ok);
    }
    var tickClock = function(){
      var c = document.getElementById('hkt-clock');
      if (!c) return;
      var now = new Date();
      var hkt = new Date(now.getTime() + (now.getTimezoneOffset() + 480) * 60000);
      var p2 = function(n){ return String(n).padStart(2,'0'); };
      c.textContent = p2(hkt.getHours()) + ':' + p2(hkt.getMinutes()) + ':' + p2(hkt.getSeconds()) + ' HKT';
    };
    setInterval(tickClock, 1000); tickClock();
  }
})();

/* ============ KV carousel：单 section 内 KV 轮播（自动+箭头+圆点+触摸） ============ */
function rokidKvCarousel(scope){
  if (!scope || !scope.querySelector) scope = document;
  var stage = scope.querySelector('.kv-stage');
  if (!stage || stage.dataset.crBound) return;
  var slides = [].slice.call(stage.querySelectorAll('.kv-slide'));
  if (!slides.length) return;
  stage.dataset.crBound = '1';
  if (stage.dataset.kvCarousel === 'false' || slides.length < 2){
    slides.forEach(function(s, i){ if (i > 0) s.style.display = 'none'; });
    return;
  }
  var idx = 0, N = slides.length;
  var interval = (parseInt(stage.dataset.kvInterval, 10) || 6) * 1000;
  var layer = document.createElement('div');
  layer.className = 'kv-cr-layer';
  var dotsHtml = '';
  for (var k = 0; k < N; k++) dotsHtml += '<button type="button" aria-label="KV ' + (k + 1) + '"></button>';
  layer.innerHTML = '<button type="button" class="kv-cr-nav kv-cr-prev" aria-label="上一张">‹</button>' +
                    '<button type="button" class="kv-cr-nav kv-cr-next" aria-label="下一张">›</button>' +
                    '<div class="kv-cr-dots">' + dotsHtml + '</div>';
  stage.appendChild(layer);
  var dots = [].slice.call(layer.querySelectorAll('.kv-cr-dots button'));
  function render(){
    slides.forEach(function(s, j){ s.style.transform = 'translateX(' + ((j - idx) * 100) + '%)'; });
    dots.forEach(function(d, j){ d.classList.toggle('on', j === idx); });
  }
  var timer = null;
  function restart(){
    clearInterval(timer);
    timer = setInterval(function(){ if (!document.hidden) go(idx + 1); }, interval);
  }
  function go(i){
    idx = ((i % N) + N) % N;
    render();
    restart();
  }
  layer.querySelector('.kv-cr-prev').addEventListener('click', function(){ go(idx - 1); });
  layer.querySelector('.kv-cr-next').addEventListener('click', function(){ go(idx + 1); });
  dots.forEach(function(d, j){ d.addEventListener('click', function(){ go(j); }); });
  var sx = 0, sy = 0;
  stage.addEventListener('touchstart', function(e){ sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, {passive:true});
  stage.addEventListener('touchend', function(e){
    var dx = e.changedTouches[0].clientX - sx;
    var dy = e.changedTouches[0].clientY - sy;
    if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.4){
      if (dx < 0) go(idx + 1); else go(idx - 1);
    }
  }, {passive:true});
  render();
  restart();
}
rokidKvCarousel(document);
if (window.Shopify && Shopify.designMode){
  document.addEventListener('shopify:section:load', function(e){ rokidKvCarousel(e.target); });
}

/* ============ scenarios 叠卡 + faq 手风琴 ============ */
function rokidNewSections(scope){
  if (!scope || !scope.querySelectorAll) scope = document;
  /* 场景叠卡：滚动驱动，后卡覆盖前卡，前卡缩小压暗 */
  var cards = [].slice.call(scope.querySelectorAll('.scn-card'));
  if (cards.length && !scope.dataset.scnBound){
    scope.dataset.scnBound = '1';
    var queued = false;
    var upd = function(){
      queued = false;
      var vh = innerHeight;
      cards.forEach(function(card, i){
        if (i === cards.length - 1){ card.style.transform = ''; card.style.filter = ''; return; }
        var next = cards[i + 1].getBoundingClientRect();
        var p = Math.min(1, Math.max(0, (vh * 0.92 - next.top) / (vh * 0.6)));
        card.style.transform = 'scale(' + (1 - 0.05 * p).toFixed(3) + ') translateY(' + (-10 * p).toFixed(1) + 'px)';
        card.style.filter = 'brightness(' + (1 - 0.22 * p).toFixed(3) + ')';
      });
    };
    addEventListener('scroll', function(){ if (!queued){ queued = true; requestAnimationFrame(upd); } }, {passive:true});
    upd();
  }
  /* FAQ 手风琴 */
  scope.querySelectorAll('.faq-item').forEach(function(item){
    if (item.dataset.faqBound) return;
    item.dataset.faqBound = '1';
    var q = item.querySelector('.faq-q');
    if (!q) return;
    q.addEventListener('click', function(){
      var open = item.classList.contains('open');
      item.parentElement.querySelectorAll('.faq-item.open').forEach(function(o){
        o.classList.remove('open');
        o.querySelector('.faq-q').setAttribute('aria-expanded', 'false');
      });
      if (!open){ item.classList.add('open'); q.setAttribute('aria-expanded', 'true'); }
    });
  });
}
rokidNewSections(document);
if (window.Shopify && Shopify.designMode){
  document.addEventListener('shopify:section:load', function(e){ rokidNewSections(e.target); });
}

/* ============ scenarios v2：hover/tap 切换 ============ */
function rokidScnSwitch(scope){
  if (!scope || !scope.querySelectorAll) scope = document;
  scope.querySelectorAll('.scn-panel').forEach(function(panel){
    if (panel.dataset.scnBound) return;
    panel.dataset.scnBound = '1';
    var items = [].slice.call(panel.querySelectorAll('.scn-item'));
    var shots = [].slice.call(panel.querySelectorAll('.scn-shot'));
    var cur = panel.querySelector('.scn-cur');
    var set = function(i){
      items.forEach(function(it, j){ it.classList.toggle('on', j === i); });
      shots.forEach(function(s, j){ s.classList.toggle('on', j === i); });
      if (cur) cur.textContent = String(i + 1).padStart(2, '0');
    };
    items.forEach(function(it, i){
      it.addEventListener('mouseenter', function(){
        if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) set(i);
      });
      it.addEventListener('click', function(){ set(i); });
    });
    panel.querySelectorAll('.scn-nav button').forEach(function(b){
      b.addEventListener('click', function(){
        var ci = items.findIndex(function(it){ return it.classList.contains('on'); });
        set((ci + Number(b.dataset.d) + items.length) % items.length);
      });
    });
  });
}
rokidScnSwitch(document);
if (window.Shopify && Shopify.designMode){
  document.addEventListener('shopify:section:load', function(e){ rokidScnSwitch(e.target); });
}
